import './index.scss';

export * from './Data';
export * from './JSON';

import SpecForms from './UI/SpecForms';
import ConnectedSpecForms from './UI/ConnectedSpecForms';

export const UI = { ConnectedSpecForms, SpecForms };
